import script from "./UserPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserPost.vue?vue&type=script&lang=ts&setup=true"

import "./UserPost.vue?vue&type=style&index=0&id=28a29e9a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a29e9a"]])

export default __exports__